import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/task-types/get-task-types'
import {
  handleSuccess,
  moduleName,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/task-types/get-task-types'
import type { GetTaskTypesParameters } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/task-types/task-types'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import { createRequestError, formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request/request.types'
import type { AxiosError } from 'axios'

import { getConfig } from '../../../../config/configuration'

const args: RequestArgs<ServerResponse, ClientResponse, GetTaskTypesParameters, never> = {
  method: 'GET',
  url: formatEndpoint(getConfig().endpoints.api.v4.taskTypes),
  handleSuccess,
  handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
}

const getTaskTypesModule = () =>
  createReduxServiceModule<ServerResponse, ClientResponse, GetTaskTypesParameters, never>({
    moduleName,
    args,
  })

export default getTaskTypesModule
